<template>
    <div class="layer-switcher">
        <div style="display: flex; align-items: center; margin-bottom: 6px;">
            <!-- Layers SVG Icon -->
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" style="margin-right: 6px;">
                <path d="M10 2L2 6.5L10 11L18 6.5L10 2Z" fill="#7F9DC3"/>
                <path d="M2 10.5L10 15L18 10.5" stroke="#7F9DC3" stroke-width="1.2" fill="none"/>
                <path d="M2 14.5L10 19L18 14.5" stroke="#7F9DC3" stroke-width="1.2" fill="none"/>
            </svg>
            <h4 style="margin: 0;">Layers</h4>
        </div>
        <ul>
            <li v-for="(layer, index) in layers" :key="index">
                <label>
                    <input
                        type="radio"
                        name="layer-switcher-radio"
                        :value="layer"
                        :checked="layer.getVisible()"
                        @change="selectLayer(layer)"
                    />
                    {{ layer.get('title') }}
                </label>
            </li>
        </ul>
    </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
    layers: {
        type: Array,
        required: true,
    },
});

const emit = defineEmits(['toggle-layer']);

function selectLayer(selectedLayer) {

    props.layers.forEach(layer => {

        if (layer === selectedLayer) {
            layer.setVisible(true);
        } else {
            layer.setVisible(false);
        }
    });

    emit("toggle-layer", selectedLayer);
}
</script>

<style scoped>

.layer-switcher {
    min-width: 180px;
    font-family: Arial, sans-serif;
    font-size: 14px;
    margin-top: 1px;
    position: absolute;
    top: 46px;
    right: 8px;
    z-index: 1;
    background: white;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 8px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}
.layer-switcher ul {
    list-style: none;
    padding: 0;
    margin: 0;
}
.layer-switcher li {
    margin-bottom: 4px;
}
/* Custom radio button color */
.layer-switcher input[type="radio"] {
    accent-color: rgb(127, 157, 195);
}
</style>
